
import {
    START_SUBSCRIBE,
    CHOOSE_SCHEDULE,
    CHOOSE_CALENDAR,
    ENTER_DETAILS,
    SEND_TO_PHONE,
    SUBSCRIBE_COMPLETE,
    SHARE,
    CALENDAR_NOT_FOUND,
    ERROR_OCCURRED,
    ALMOST_DONE_PROC,
    ALMOST_DONE_PROC_TIMEOUT,
    NEW_OUTLOOK_CALENDAR,
} from './gaEvents';
import { GA_ENABLED } from './gaInitGTag';

function fireGoolgeAnalytics (params) {
    if (!GA_ENABLED) return;

    const {
        action,
        label,
    } = params;
 
    this.getGAParams(action);
    if (window.gtag && typeof window.gtag === 'function') {
        console.log('');
        console.log('');
        console.log('fireGoolgeAnalytics() GA Params -> ', this.gaParams);
        window.gtag('event', action, {
            label : `${label} (Widget-V2)`,
            // label,
            'publisher': this.gaParams.publisher ,
            'dimensions': this.gaParams.dimensions, 
        });
    }
}

function gaStartSubscribe () {
    this.fireGoolgeAnalytics ( {
        ...START_SUBSCRIBE,
    });
};

function gaChooseSchedule () {
    this.fireGoolgeAnalytics ( {
        ...CHOOSE_SCHEDULE,
    });
};

export function gaChooseCalendar () {
    this.fireGoolgeAnalytics ( {
        ...CHOOSE_CALENDAR,
    });
};

function gaEnterDetails () {
    this.fireGoolgeAnalytics ( {
        ...ENTER_DETAILS,
    });
};

function gaSendToPhone () {
    this.fireGoolgeAnalytics ( {
        ...SEND_TO_PHONE,
    });
};

function gaSubscribeComplete () {
    this.fireGoolgeAnalytics ( {
        ...SUBSCRIBE_COMPLETE,
    });
};

function gaShare () {
    this.fireGoolgeAnalytics ( {
        ...SHARE,
    });
};

function gaCalendarNotFound () {
    this.fireGoolgeAnalytics ( {
        ...CALENDAR_NOT_FOUND,
    });
};
 
function gaError () {
    this.fireGoolgeAnalytics ( {
        ...ERROR_OCCURRED,
    });
};

function gaAlmostDoneProc () {
    this.fireGoolgeAnalytics ( {
        ...ALMOST_DONE_PROC,
    });
};

function gaAlmostDoneProcTimeout () {
    this.fireGoolgeAnalytics ( {
        ...ALMOST_DONE_PROC_TIMEOUT,
    });
};

function gaNewOutlookCalendar () {
    this.fireGoolgeAnalytics ( {
        ...NEW_OUTLOOK_CALENDAR,
    });
  }

const gaActions = {
    fireGoolgeAnalytics,
    gaStartSubscribe,
    gaChooseSchedule,
    gaChooseCalendar,
    gaEnterDetails,
    gaSendToPhone,
    gaSubscribeComplete,
    gaShare,
    gaCalendarNotFound,
    gaError,
    gaAlmostDoneProc,
    gaAlmostDoneProcTimeout,
    gaNewOutlookCalendar,
};

export default gaActions;
